module.exports = __webpack_public_path__ + "static/assets/0a7e3ccbaa6483f87a53ebe4403c3400.png";